import {Entity} from '../../core/commons/entity';
import {FormViewField} from './form-view-field';
import { User } from 'app/core/domain/user';


export class FormView implements Entity {
  id: number;
  name: string;
  createdBy: User;
  version: number;
  active: boolean;
  validSince: number;
  validUntil: number;
  createdTime: number;
  previousVersion: FormView;
  fields: FormViewField[] = [];

  constructor(value: Object = {}) {
    Object.assign(this, value);
    if (this.fields) {
      this.fields = this.fields.map( f => new FormViewField(f) );
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/form-views/domain/form-view.ts